// eslint-disable-next-line import/prefer-default-export
import Vue from "vue";
export const installationsMutations = {
    PUSH_INSTALLATION: (state, installation) => {
        Vue.set(state.installations, installation.key, installation)
    },
    HIDE_INSTALLATION: (state, key) => {
        Vue.set(state.installations[key], "hide", true)
    },
    REMOVE_INSTALLATION: (state, key) => {
        Vue.delete(state.installations, key)
    },
    REMOVE_INSTALLATIONS: (state) => {
        state.installations = []
    },
    SET_INSTALLATIONS: (state, installations) => {
        state.installations = installations
    },

    UPDATE_INSTALLATION: (state, data) => {
        let installations = state.installations
        const installation_index = installations.indexOf(installations.find(i => i.installation_id == data.installation_id))
        state.installations[installation_index] = { ...installations[installation_index], ...data.install }
    },

    SET_INSTALLATION_LOSS: (state, data) => {
        let installations = state.installations
        const installation_index = installations.indexOf(installations.find(i => i.installation_id == data.installation_id))
        installations[installation_index] = { ...installations[installation_index], ...data.loss }
        state.installations = installations
    },

    SET_INSTALLATION_SUBARRAY: (state, data) => {
        let installations = state.installations
        const installation_index = installations.indexOf(installations.find(i => i.installation_id == data.installation_id))
        installations[installation_index] = {
            ...installations[installation_index], ...{
                subarrays: [
                    data.subarray
                ]
            }
        }
        state.installations = installations
    },

    SET_CUR_INSTALL_ID: (state, int) => {
        state.cur_install_id = int
    },

    SET_IS_FILTRED_BY_GEO: (state, bool) => {
        state.is_filtred_by_geo = bool
    }
};
